import { createReducer } from 'redux-act';

import MenuCategoriesData from '../../models/MenuCategoriesData';
import { menucategoriesSaveSucceeded, SaveMenuCategoriesPayload } from '../actions/menucategories/saveMenuCategories';

export interface MenuCategoriesReducerState {
  readonly data: MenuCategoriesData[];
}

const defaultState: MenuCategoriesReducerState = {
  data: [
    { uuid: '1', myString: 'Levesek', enabled: true },
    { uuid: '2', myString: 'Koretek', enabled: false },
    { uuid: '3', myString: 'Italok', enabled: false },
  ],
};

const menucategoriesReducer = createReducer<MenuCategoriesReducerState>({}, defaultState);

menucategoriesReducer.on(menucategoriesSaveSucceeded, (previousMenuCategoriesState: MenuCategoriesReducerState, actionPayload: SaveMenuCategoriesPayload) => {
  const { data } = actionPayload;
  return { ...previousMenuCategoriesState, data };
});

export default menucategoriesReducer;
